export default __webpack_public_path__ + "static/media/avatar6.ce4b99ea.png";